export default __webpack_public_path__ + "images/Bigship_Icon.png";